import React from 'react'
import styled from 'styled-components'

import UserTag from '../../assets/icons/user-tag'

const Svg = styled.svg`
  fill: #cacad2;
  width: 24px;
  height: 24px;
`

export const UserTagIcon = ({ className }) => {
  return <Svg as={UserTag} className={className} />
}
